export enum ProductType {
    GUEST = 'guest',
    TRIAL = 'trial',
    PRO = 'pro',
    BASIC = 'basic', // deprecated
    ENTERPRISE = 'enterprise',
    ENTERPRISE_TRIAL = 'enterprise-trial',
    LITE = 'lite',
    ADVANCED = 'advanced',
    BUILD = 'build',
    LAUNCH = 'launch',
    SCALE = 'scale',
}

export enum PlanGroup {
    GUEST = 'deid-guest',
    TRIAL = 'deid-trial',
    LITE = 'deid-lite',
    PRO = 'deid-pro',
    ADVANCED = 'deid-advanced',
    ENTERPRISE = 'deid-enterprise',
    ENTERPRISE_TRIAL = 'deid-enterprise-trial',
    BUILD = 'deid-api-build',
    LAUNCH = 'deid-api-launch',
    SCALE = 'deid-api-scale',
    FREE = 'deid-free',
    CREATOR = 'deid-creator',
    BUSINESS = 'deid-business',
}

export const checkProductMatch = {
    GUEST: (product?: string) => !!product && [PlanGroup.GUEST, ProductType.GUEST].includes(product as any),
    TRIAL: (product?: string) => !!product && [PlanGroup.TRIAL, ProductType.TRIAL].includes(product as any),
    PRO: (product?: string) => !!product && [PlanGroup.PRO, ProductType.PRO].includes(product as any),
    ENTERPRISE: (product?: string) =>
        !!product && [PlanGroup.ENTERPRISE, ProductType.ENTERPRISE].includes(product as any),
    ENTERPRISE_TRIAL: (product?: string) =>
        !!product && [PlanGroup.ENTERPRISE_TRIAL, ProductType.ENTERPRISE_TRIAL].includes(product as any),
    LITE: (product?: string) => !!product && [PlanGroup.LITE, ProductType.LITE].includes(product as any),
    ADVANCED: (product?: string) => !!product && [PlanGroup.ADVANCED, ProductType.ADVANCED].includes(product as any),
    BUILD: (product?: string) => !!product && [PlanGroup.BUILD, ProductType.BUILD].includes(product as any),
    LAUNCH: (product?: string) => !!product && [PlanGroup.LAUNCH, ProductType.LAUNCH].includes(product as any),
    SCALE: (product?: string) => !!product && [PlanGroup.SCALE, ProductType.SCALE].includes(product as any),
};

export const productToProductName: Record<string, string> = {
    [ProductType.TRIAL]: 'trial',
    [ProductType.PRO]: 'pro',
    [ProductType.ENTERPRISE]: 'enterprise',
    [ProductType.ENTERPRISE_TRIAL]: 'enterprise-trial',
    [ProductType.LITE]: 'lite',
    [ProductType.ADVANCED]: 'advanced',
    [ProductType.GUEST]: 'guest',
    [ProductType.BUILD]: 'build',
    [ProductType.LAUNCH]: 'launch',
    [ProductType.SCALE]: 'scale',
    [PlanGroup.GUEST]: 'guest',
    [PlanGroup.TRIAL]: 'trial',
    [PlanGroup.PRO]: 'pro',
    [PlanGroup.ENTERPRISE]: 'enterprise',
    [PlanGroup.ENTERPRISE_TRIAL]: 'enterprise-trial',
    [PlanGroup.LITE]: 'lite',
    [PlanGroup.ADVANCED]: 'advanced',
    [PlanGroup.BUILD]: 'build',
    [PlanGroup.LAUNCH]: 'launch',
    [PlanGroup.SCALE]: 'scale',
    [PlanGroup.FREE]: 'free',
    [PlanGroup.CREATOR]: 'creator',
    [PlanGroup.BUSINESS]: 'business',
};

export const isEnterprisePlan = (plan: PlanGroup | undefined) =>
    plan && [PlanGroup.ENTERPRISE, PlanGroup.ENTERPRISE_TRIAL].includes(plan);

export const isEnterpriseProduct = (plan: ProductType | undefined) =>
    plan && [ProductType.ENTERPRISE, ProductType.ENTERPRISE_TRIAL].includes(plan);
